import CollapsibleItem from './CollapsibleItem'

export default CollapsibleItem



// WEBPACK FOOTER //
// ./src/app/elements/CollapsibleItem/index.js